module.exports = __webpack_public_path__ + "static/media/ProjectsInactive.d74f8ae0.png";